import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungNeuss() {
  return (
    <CityPageTemplate
      city="Neuss"
      slug="neuss"
      intro="Neuss als Teil der Metropolregion Düsseldorf – digitale, unabhängige Finanzberatung direkt für Dich."
      description="Unabhängige & digitale Finanzberatung für Neuss: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
